export default function formStepper (document, moduleHTML, appEventEmitter) {
  const form = moduleHTML
  const formSteps = Array.from(form.querySelectorAll('[data-js-outer-form-step]'))
  const submitButton = form.querySelector('[type="submit"]')
  const formTitle = form.querySelector('[data-js-form-title]')

  let currentStep = 0
  const lastStep = Number(formSteps.reduce((acc, formStep) => {
    const thisStep = formStep.dataset.jsOuterFormStep
    return thisStep > acc ? thisStep : acc
  }, 0))

  const requiredCheckboxes = (element) => {
    const allRelatedCheckboxes = Array.from(document.querySelectorAll(`input[name="${element.name}"]`))
    const customValidityMessage = 'Please select at least one option.'
    element.addEventListener('input', (event) => {
      const anyChecked = allRelatedCheckboxes.reduce((acc, relatedCheckbox) => {
        return relatedCheckbox.checked || acc
      }, false)
      allRelatedCheckboxes.forEach((element) => {
        element.required = !anyChecked
        element.setCustomValidity(!anyChecked ? customValidityMessage : '')
      })
    })
  }

  const updateStep = (element, isCurrentStep) => {
    element.classList.toggle('hidden')
    if (element.dataset.jsOuterFormStepRequired && isCurrentStep) {
      // need to defer setting required for steps other than the first
      // browsers throw errors when trying to show a required tooltip on hidden elements
      element.querySelectorAll('input, textarea').forEach((element) => {
        element.required = true
        // TODO: Later copy the following condition part to dcom gatsby when need to display button-checkbox with {required=true} inside form-stepper
        if (element.type === 'checkbox') {
          requiredCheckboxes(element)
        }
      })
    }
    if (element.dataset.jsOuterFormStepTitle) formTitle.innerText = element.dataset.jsOuterFormStepTitle
  }

  const proceedToNextStep = (currentStep, increment = 1) => {
    const previousFormSteps = formSteps.filter((formStep) => {
      return Number(formStep.dataset.jsOuterFormStep) === currentStep
    })
    const nextFormSteps = formSteps.filter((formStep) => {
      return Number(formStep.dataset.jsOuterFormStep) === currentStep + increment
    })

    previousFormSteps.forEach((previousFormStep) => updateStep(previousFormStep, false))
    nextFormSteps.forEach((nextFormStep) => updateStep(nextFormStep, true))

    // Store the progress in the data attribute so other scripts can check it
    form.dataset.jsFormStepper = `${currentStep + increment}:${lastStep}`

    return currentStep + increment
  }

  form.addEventListener('submit', (event) => {
    let stepsToSkip, conditionalSubmit, conditionalSkip

    formSteps.filter((formStep) => {
      return Number(formStep.dataset.jsOuterFormStep) === currentStep
    })
      .forEach((currentFormStep) => {
        let acceptedValue = ''
        const currentStepInputs = Array.from(currentFormStep.querySelectorAll('input, textarea'))
        const conditionSatisfied = currentStepInputs.reduce((acc, currentStepInput) => {
          const inputDataset = currentStepInput.dataset
          if (inputDataset.jsFormStepSubmitIfValue) {
            acceptedValue = inputDataset.jsFormStepSubmitIfValue
          } else if (inputDataset.jsFormStepSkipIfValue && inputDataset.jsFormStepSkipIfValue.includes(':')) {
            [acceptedValue, stepsToSkip] = inputDataset.jsFormStepSkipIfValue.split(':')
          } else {
            return false
          }

          const isFieldset = ['radio', 'checkbox'].includes(currentStepInput.type)
          const valueMatches = isFieldset
            ? (currentStepInput.checked && currentStepInput.value === acceptedValue)
            : currentStepInput.value === acceptedValue

          return acc || valueMatches
        }, false)

        if (stepsToSkip) {
          conditionalSkip = conditionSatisfied
        } else {
          conditionalSubmit = conditionSatisfied
        }
      })

    if (conditionalSubmit) {
      // If conditionalSubmit is true, the current step is now the last step
      // To ensure form-recaptcha does not prevent submission, this is set accordingly
      form.dataset.jsFormStepper = 'ready'
    }

    if (currentStep < lastStep && !conditionalSubmit) {
      event.preventDefault()
      if (conditionalSkip) {
        currentStep = proceedToNextStep(currentStep, Number(stepsToSkip) + 1)
      } else {
        currentStep = proceedToNextStep(currentStep)
      }
      if (currentStep === lastStep) submitButton.innerText = 'Submit'
    }
  })
}
